// Integrations API. Methods are bound to the shared ApiClient instance
// via Object.assign in src/utils/api.js.
export function createIntegrationsApi(client) {
  return {
    async dailyResetUser() {
      try {
        await this.call('/daily-reset-user', {
          method: 'POST'
        })
      } catch (error) {
        console.error('Daily reset failed:', error)
      }
    }
  }
}
